import { PaymentMethod, PaymentOperation } from "@phonero/common-graphql/types"
import {
    DevDetails,
    Loading,
    useAppTranslations
} from "@phonero/common-ux"
import { PuxButton, PuxSheet } from "@phonero/pux-react"
import { PageContent } from "../../../components/layout"
import { uncompletedPurchases } from "../../../util/reactiveVars"
import { useAppRouterDP } from "../../../util/useAppRouterDP"
import { useOutstandingPayments } from "../../../util/useOutstandingPayments"
import { usePaymentDetailPoller } from "./usePaymentDetailPoller"
import { useRecurringPaymentDetailPoller } from "./useRecurringPaymentDetailPoller"
import { VippsPaymentOrderStatusText } from "./VippsPaymentOrderStatusText"
import { VippsRecurringOrderStatusText } from "./VippsRecurringOrderStatusText"

const PaymentCallbackPage = ({
  paymentID, paymentMethod  
}: {paymentID: string | undefined, paymentMethod: PaymentMethod}) => {
  console.log("paymentID", paymentID)  
  
  const paymentIdVipps = paymentMethod === PaymentMethod.Vipps ? paymentID : undefined
  const paymentIdVippsRecurring = paymentMethod === PaymentMethod.Vippsrecurring ? paymentID : undefined

  const paymentDetails =
    usePaymentDetailPoller(paymentIdVipps)
  const recurringPaymentDetails =
    useRecurringPaymentDetailPoller(paymentIdVippsRecurring)

  if (!paymentIdVipps && !paymentIdVippsRecurring) {
    throw new Error("Missing both paymentID and paymentIDRecurring.")
  }

  const { order, lastState, states, paymentDetail } =
    paymentDetails ??
    recurringPaymentDetails ?? {
      order: null,
      lastState: null,
      states: [],
      paymentDetail: null,
    }

  const { purchases, remove } = useOutstandingPayments()
  const { goTo } = useAppRouterDP()
  const paymentIdToUse = paymentID || ""
  const thisUncompleted = purchases?.[paymentIdToUse]
  const { t, i18n } = useAppTranslations()
  const handleOnCancel = () => {
    remove(paymentIdToUse)
    const { [paymentIdToUse]: _omit, ...rest } = purchases || {}
    const nextPayment = Object.values(rest)[0]
    if (nextPayment) {
      goTo("paymentStatus.cancel", null, {
        paymentID: nextPayment.paymentID,
      }).paymentCallbackVipps()
    } else {
      goTo("paymentStatus.cancel").home()
    }
  }

  if (thisUncompleted && !thisUncompleted?.isRedirected) {
    uncompletedPurchases.add({ ...thisUncompleted, isRedirected: true })
    window.location.href = thisUncompleted?.paymentURI!
  }

  return (
    <PageContent>
      <PuxSheet color="light" style={{ height: "100%", textAlign: "center" }}>
        {/* {loading && <Loading />} */}
        {!!paymentDetails && (
          <VippsPaymentOrderStatusText
            orderStatus={order?.status}
            orderMessage={order?.orderStatusMessage}
            /*error={subscriptionDetailsWithDataError}*/
            /*errorType={errorType}*/
            paymentStatus={lastState?.operation}
            amount={
              // Amounts in payments are in hundreds of NOK
              (lastState?.amount || 0) / 100 || thisUncompleted?.amount
            }
            productText={
              thisUncompleted?.productName ||
              order?.receipt?.productName ||
              thisUncompleted?.productText
            }
            receipt={order?.receipt}
            productID={thisUncompleted?.productID}
          />
        )}
        {!!recurringPaymentDetails && (
          <VippsRecurringOrderStatusText
            orderStatus={order?.status}
            orderMessage={order?.orderStatusMessage}
            /*error={subscriptionDetailsWithDataError}*/
            /*errorType={errorType}*/
            agreementStatus={order?.vippsAgreementDetails?.status}
            /* amount={
              // Amounts in payments are in hundreds of NOK
              (lastState?.amount || 0) / 100 || thisUncompleted?.amount
            }*/
            // productText={
            //   thisUncompleted?.productName ||
            //   order?.receipt?.productName ||
            //   thisUncompleted?.productText
            // }
            vippsAgreementDetails={order?.vippsAgreementDetails}
            productID={thisUncompleted?.productID}
          />
        )}
        {lastState?.operation === PaymentOperation.Initate &&
        thisUncompleted &&
        thisUncompleted.paymentURI ? (
          <div title={i18n.format(thisUncompleted.date)}>
            <PuxButton
              style={{ marginTop: 20 }}
              color="primary"
              size="small"
              href={thisUncompleted.paymentURI}
            >
              {t("PaymentCallBack.PaymentUrl", {
                ...thisUncompleted,
              })}
            </PuxButton>

            <PuxButton
              style={{ marginTop: 20 }}
              color="dark"
              size="small"
              onClick={handleOnCancel}
            >
              {t("PaymentCallBack.Cancel", {
                ...thisUncompleted,
              })}
            </PuxButton>
          </div>
        ) : !!paymentDetail?.error && !!thisUncompleted ? (
          <div>
            <PuxButton
              style={{ marginTop: 20 }}
              color="dark"
              size="small"
              onClick={handleOnCancel}
            >
              {t("PaymentCallBack.Cancel", {
                ...thisUncompleted,
              })}
            </PuxButton>
          </div>
        ) : null}
        {window.location.hostname === "localhost" && (
          <DevDetails
            data={{
              uncompleted: purchases,
              paymentDetail,
              states,
              order,
              lastState,
            }}
          />
        )}
      </PuxSheet>
    </PageContent>
  )
}
// Sometimes, it was observed a completely empty error-message from Apollo here, but with a stacktrace
/*const isEmptyError = (error?: any) => {
  if (error === undefined || error === null) {
    return null
  }
  return error?.message || error?.stack?.split?.("\n")?.[0] || "Unknown error"
}*/

export default PaymentCallbackPage
